import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { getProfile } from 'apis/controllers/membership';
import ProfileForm from './ProfileForm';
import { CircularProgress, Grid } from '@mui/material';
import { getAgreements } from 'apis/controllers/generic';

const Profile = () => {
    const { personId } = useParams(); // Get person ID from URL
    const [customDob, setCustomDob] = useState(null);

    // If there's an ID, fetch person data
    const agreementsQuery = useQuery(
        ['agreements', personId, customDob],
        async () => {
            const res = await getAgreements({
                DataKey: 'Person',
                RecordGuid: personId,
                customDob: customDob && !personId ? customDob : null
            });

            return res?.data;
        },
        { enabled: !!personId || !!customDob }
    ); // Only fetch when editing);
    const personQuery = useQuery(
        ['profile', personId],
        async () => {
            const res = await getProfile({ Id: personId });
            return res;
        },
        { enabled: !!personId } // Only fetch when editing
    );

    if (personQuery?.isLoading)
        return (
            <Grid container sx={{ height: '70h', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress />
            </Grid>
        );

    return (
        <ProfileForm
            mode={personId ? 'edit' : 'create'}
            personQuery={personQuery}
            agreementsQuery={agreementsQuery}
            setCustomDob={setCustomDob}
        />
    );
};

export default Profile;
